var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 130,
    viewBox: "0 0 187 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5182_22340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.676 59.5447C156.508 59.5447 162.856 56.4971 162.856 52.7378C162.856 48.9784 156.508 45.9309 148.676 45.9309C140.845 45.9309 134.497 48.9784 134.497 52.7378C134.497 56.4971 140.845 59.5447 148.676 59.5447Z",
    stroke: "#00BFFC",
    strokeWidth: 0.798122,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9864 128.073C45.8177 128.073 52.1662 125.025 52.1662 121.266C52.1662 117.507 45.8177 114.459 37.9864 114.459C30.1551 114.459 23.8066 117.507 23.8066 121.266C23.8066 125.025 30.1551 128.073 37.9864 128.073Z",
    stroke: "#976CF3",
    strokeWidth: 0.798122,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.7447 129.654C144.668 129.654 185.95 110.641 185.95 87.1874C185.95 63.734 144.668 44.7212 93.7447 44.7212C42.821 44.7212 1.53918 63.734 1.53918 87.1874C1.53918 110.641 42.821 129.654 93.7447 129.654Z",
    stroke: "url(#paint0_linear_5182_22340)",
    strokeWidth: 1.19718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.052 108.79C143.976 108.79 185.258 89.7771 185.258 66.3236C185.258 42.8702 143.976 23.8574 93.052 23.8574C42.1283 23.8574 0.846436 42.8702 0.846436 66.3236C0.846436 89.7771 42.1283 108.79 93.052 108.79Z",
    stroke: "url(#paint1_linear_5182_22340)",
    strokeWidth: 1.19718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.948 85.2786C144.872 85.2786 186.154 66.2659 186.154 42.8124C186.154 19.359 144.872 0.346191 93.948 0.346191C43.0243 0.346191 1.74243 19.359 1.74243 42.8124C1.74243 66.2659 43.0243 85.2786 93.948 85.2786Z",
    stroke: "url(#paint2_linear_5182_22340)",
    strokeWidth: 1.19718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1617 78.0817C43.1617 78.0817 2.71928 67.0024 1.77242 43.9204L1.54148 87.1991C1.54148 87.1991 -1.54159 103.363 30.5592 118.621L43.1617 78.0817Z",
    fill: "url(#paint3_linear_5182_22340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8133 78.0818C28.5314 80.7756 25.3503 84.9066 23.8411 89.7333C22.3319 94.56 22.5934 99.7663 24.5788 104.418C26.5641 109.069 30.1432 112.861 34.6736 115.112C39.204 117.364 44.389 117.928 49.2979 116.703C46.6938 118.336 43.7663 119.385 40.7172 119.779C37.6681 120.172 34.5698 119.901 31.636 118.982C28.7022 118.063 26.0025 116.52 23.7229 114.458C21.4434 112.396 19.6383 109.865 18.4319 107.039C17.2255 104.212 16.6466 101.158 16.735 98.0865C16.8234 95.0149 17.5771 91.9991 18.944 89.2467C20.311 86.4944 22.2588 84.0709 24.6531 82.1435C27.0475 80.216 29.8315 78.8303 32.8133 78.0818Z",
    fill: "#825FD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8574 96.081C22.8549 92.4828 23.7671 88.943 25.5086 85.7937C27.2501 82.6445 29.7636 79.9892 32.8133 78.0771C37.7247 76.8447 42.9149 77.4042 47.4506 79.6548C51.9862 81.9055 55.5696 85.6996 57.5564 90.3549C59.5432 95.0103 59.8031 100.221 58.2892 105.051C56.7754 109.881 53.5871 114.012 49.2979 116.702C46.1616 117.486 42.8881 117.545 39.7257 116.875C36.5633 116.205 33.5951 114.823 31.0466 112.836C28.498 110.848 26.436 108.306 25.0171 105.403C23.5981 102.5 22.8596 99.312 22.8574 96.081Z",
    fill: "#976CF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.845 10.2346C153.845 10.2346 186.408 22.6204 186.154 42.8125C185.9 63.0046 185.946 87.6493 185.946 87.6493C185.946 87.6493 190.253 65.7837 142.73 51.2651L153.845 10.2346Z",
    fill: "url(#paint4_linear_5182_22340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.845 10.2346C158.128 12.9283 161.309 17.0596 162.819 21.8867C164.328 26.7139 164.066 31.9207 162.081 36.5724C160.095 41.2241 156.515 45.0159 151.984 47.2671C147.453 49.5183 142.267 50.0815 137.358 48.8554C139.962 50.4909 142.891 51.5425 145.941 51.9376C148.991 52.3327 152.091 52.0619 155.026 51.1439C157.961 50.2259 160.663 48.6825 162.944 46.6202C165.224 44.5578 167.031 42.0256 168.238 39.1981C169.445 36.3706 170.024 33.3151 169.935 30.2422C169.846 27.1694 169.092 24.1523 167.724 21.3991C166.356 18.6459 164.406 16.2219 162.01 14.2945C159.614 12.367 156.828 10.9819 153.845 10.2346Z",
    fill: "#059ED3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.808 28.234C163.81 24.6357 162.898 21.0959 161.157 17.9467C159.415 14.7974 156.902 12.1421 153.852 10.23C148.942 9.00011 143.754 9.56081 139.22 11.8113C134.686 14.0619 131.104 17.8547 129.118 22.5081C127.131 27.1616 126.871 32.3707 128.382 37.1991C129.894 42.0276 133.079 46.159 137.365 48.8508C140.501 49.634 143.775 49.6929 146.937 49.0229C150.1 48.3529 153.068 46.9717 155.617 44.984C158.166 42.9964 160.228 40.4546 161.647 37.5515C163.066 34.6485 163.805 31.4604 163.808 28.2293V28.234Z",
    fill: "#00BFFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5182_22340",
    x1: 1.19277,
    y1: 87.1874,
    x2: 186.297,
    y2: 87.1874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5182_22340",
    x1: 0.500024,
    y1: 66.3236,
    x2: 185.604,
    y2: 66.3236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5182_22340",
    x1: 1.39602,
    y1: 42.8124,
    x2: 186.5,
    y2: 42.8124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5182_22340",
    x1: 1.45834,
    y1: 81.2647,
    x2: 43.1617,
    y2: 81.2647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976CF3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#976CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5182_22340",
    x1: 142.73,
    y1: 48.9408,
    x2: 186.154,
    y2: 48.9408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5182_22340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 130,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.57eba9c5868b018227a15e7e779e28f0.svg";
export { ForwardRef as ReactComponent };